var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTikSquare2 = function SvgTikSquare2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M3.25 0A3.25 3.25 0 0 0 0 3.25v11.5A3.25 3.25 0 0 0 3.25 18h11.5A3.25 3.25 0 0 0 18 14.75V3.25A3.25 3.25 0 0 0 14.75 0H3.25Zm11.03 6.28-6.754 6.747a.75.75 0 0 1-1.06 0L3.72 10.28a.75.75 0 0 1 1.06-1.06l2.217 2.216 6.223-6.217a.75.75 0 1 1 1.06 1.062"
  })));
};
export default SvgTikSquare2;